<template>
  <div class="homeGuest">
    <Header/>
    <div class="market1">
      <div class="market1_title">
          The best tool for agile sprint retrospectives
      </div>
      <div class="market1_text">
          Collaborate with your team to improve the development process. And it's free.
      </div>
      <div class="market1_buttons">
          <vue-recaptcha
              :loadRecaptchaScript="true"
              @verify="onVerify"
              class="grecaptcha_wrapper"
              sitekey="6LcN98IUAAAAAELEa7A2LBZDSdwytL1zDEoV5ycV"
          >
              <button class="button_ok button">
                  Start Retro
              </button>
          </vue-recaptcha>
          <router-link v-bind:to="'/signup'" class="button button_cancel">
              Create Team
          </router-link>
      </div>
    </div>
    <div class="market2 market_center">
        <img src="~images/marketing-2.png" alt="" />
    </div>
    <div class="market-gradient">
      <div class="market_center market3">
          <div class="market3_left">
              <div>
                  <div class="market3_title">
                      What is a sprint retrospective?
                  </div>
                  <div class="market3_text">
                      The sprint retrospective is an opportunity for the scrum team to inspect itself and create a plan for improvements to be enacted during the next sprint.
                  </div>
              </div>
          </div>
          <div class="market3_right">
              <img src="~images/marketing-3.png" alt=""  />
          </div>
      </div>
      <div class="market_center market4">
          <div class="market4_item">
              <div class="market4_item-icon">
                  <img src="~images/marketing-4-collaboration.svg" alt="">
              </div>
              <div class="market4_item-title">
                  Real-time Collaboration
              </div>
              <div class="market4_item-text">
                  Instanly create your retrospective meetings and collaborate with your team in real-time.
              </div>
          </div>
          <div class="market4_item">
              <div class="market4_item-icon">
                  <img src="~images/marketing-4-voting.svg" alt="">
              </div>
              <div class="market4_item-title">
                  Issue Voting
              </div>
              <div class="market4_item-text">
                  Team members vote on talking points in order to surface the most relevant and important issues.
              </div>
          </div>
          <div class="market4_item">
              <div class="market4_item-icon">
                  <img src="~images/marketing-4-team.svg" alt="">
              </div>
              <div class="market4_item-title">
                  @mention Teammates
              </div>
              <div class="market4_item-text">
                  Mention your teammates to send them an email with the specific talking point.
              </div>
          </div>
          <div class="market4_item">
              <div class="market4_item-icon">
                  <img src="~images/marketing-4-lock.svg" alt="">
              </div>
              <div class="market4_item-title">
                  Admin Controls
              </div>
              <div class="market4_item-text">
                  Lock your team's retrospectives, manage admin rights, and create multiple teams.
              </div>
          </div>
      </div>
      <div class="market_center market5">
          <div class="market5_left">
              <!-- <div class="market5_title">Free</div>
              <div class="market5_fee">$0</div>
              <div class="market5_time">Seriously, free</div>
              <div class="market5_text">Free public retrospective boards</div> -->
              <div class="market5_list">
                  <div class="market5_list__inf-light">
                      Unlimited public retros
                  </div>
                  <div class="market5_list__check-light">
                      Real-time collaboration
                  </div>
                  <div class="market5_list__check-light">
                      Issue voting
                  </div>
                  <div class="market5_list__circle-light">
                      Export options (coming soon)
                  </div>
              </div>
              <vue-recaptcha
                  :loadRecaptchaScript="true"
                  @verify="onVerify"
                  class="grecaptcha_wrapper"
                  sitekey="6LcN98IUAAAAAELEa7A2LBZDSdwytL1zDEoV5ycV"
              >
                  <button class="button_cancel button">
                      Start free Retro
                  </button>
              </vue-recaptcha>
          </div>
          <div class="market5_right">
              <!-- <div class="market5_title">Team</div>
              <div class="market5_fee">$20</div>
              <div class="market5_time">USD per month</div>
              <div class="market5_text">Everything included in Free, plus:</div> -->
              <div class="market5_list">
                  <div class="market5_list__inf">
                      Unlimited private retros
                  </div>
                  <div class="market5_list__inf">
                      Unlimited team members
                  </div>
                  <div class="market5_list__check">
                      @ mention team members
                  </div>
                  <div class="market5_list__check">
                      Team management
                  </div>
                  <div class="market5_list__check">
                      Custom templates
                  </div>
                  <div class="market5_list__check">
                      Admin controls
                  </div>
                  <div class="market5_list__circle">
                      Slack integration (coming soon)
                  </div>
              </div>

              <router-link v-bind:to="'/signup'" class="button button_ok">
                  Create Team
              </router-link>
          </div>
      </div>
    </div>
    <div class="market-footer">
        <div class="market-footer_title">
            Need help?
        </div>
        <a href="mailto:support@ezretro.com" class="market-footer_mail">
            support@ezretro.com
        </a>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import db,{ AUTH, ANALYTICS } from 'src/firebase-config';
import VueRecaptcha from 'vue-recaptcha';
import Header from "./elements/Header";

export default {
  components: { VueRecaptcha, Header},
  methods: {
    onVerify: function() {
      db.collection('retros')
        .add({
          retroName: '',
          createdDate: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(snap => {
          this.$router.push(snap.id);
        });
    }
  },
  mounted() {
    document.title = 'EZ Retro - Agile Team Retrospective Tool';
    document.description = 'A tool for agile teams to collaborate and improve with retrospectives.';
    ANALYTICS.logEvent('page_view');
  },
  beforeMount() {
    if(AUTH.currentUser){
      this.$router.push('/dashboard');
    }
  }
};
</script>

<style scoped>
html,
body {
  height: 100%;
}
</style>
